
const croco = {
    utils: {
        strLen: (val) => {
            let str = new String(val);
            let arr = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]|[^\uD800-\uDFFF]/g) || [];
            return arr.length;    
        },
        numberformat: (val) => {
            return new Intl.NumberFormat(
                'en-IN', { 
                    maximumSignificantDigits: 3 
                }
            ).format(val);
        },
        addIFrame: (src) => {
            let root = document.createElement('iframe'); 

            root.setAttribute('src', src);
            document.body.appendChild(root);

            setTimeout(()=> {
                document.body.removeChild(root);
            }, 1000);
        },
        byteformat: (size) => {
            let sizes =[' B', ' KB', ' MB', ' GB', ' TB', ' PB', ' EB'];
            let ext = sizes[0];
            if (typeof size === 'number') {
                for (var idx =1; idx < sizes.length; idx += 1) {
                    if (size >= 1024) {
                        size = size / 1024;
                        ext = sizes[idx];
                    }
                }
            } // if (typeof size === 'number')
            return Math.round(size, 2) + ext;
        }
    }
};

export default croco;
